import { generateTypes } from '../../utils/HttpReducerHelper';

const cancelFundingSearchMatch = generateTypes(
  'FUNDING_SEARCH_MATCH',
  'CANCEL_FUNDING_SEARCH_MATCH',
);
const fundingMatchStatus = generateTypes('MATCH', 'FUNDING_MATCH_STATUS');
const CLOSE_CANCEL_FUNDING_SEARCH_MATCH_MODAL = 'CLOSE_CANCEL_FUNDING_SEARCH_MATCH_MODAL';
const OPEN_CANCEL_FUNDING_SEARCH_MATCH_MODAL = 'OPEN_CANCEL_FUNDING_SEARCH_MATCH_MODAL';
const SET_IGNORED_MATCH_STATUSES = 'SET_IGNORED_MATCH_STATUSES';
const SET_FETCHING_OFFER_MATCH_IDS = 'SET_FETCHING_OFFER_MATCH_IDS';
const SET_FUNDING_MATCH_NOTIFICATION = 'SET_FUNDING_MATCH_NOTIFICATION';
const DELETE_FETCHING_OFFER_MATCH_ID = 'DELETE_FETCHING_OFFER_MATCH_ID';

const SSE_UPDATE_FUNDING_MATCH = '@@SSE/funding/match/status_update';
const SSE_UPDATE_FUNDING_MATCH_SUCCESS = '@@SSE/funding/match/status_update_success';
const SSE_UPDATE_FUNDING_MATCH_FAILURE = '@@SSE/funding/match/status_update_failure';

export {
  fundingMatchStatus,
  cancelFundingSearchMatch,
  CLOSE_CANCEL_FUNDING_SEARCH_MATCH_MODAL,
  OPEN_CANCEL_FUNDING_SEARCH_MATCH_MODAL,
  SET_IGNORED_MATCH_STATUSES,
  SET_FETCHING_OFFER_MATCH_IDS,
  SET_FUNDING_MATCH_NOTIFICATION,
  DELETE_FETCHING_OFFER_MATCH_ID,
  SSE_UPDATE_FUNDING_MATCH,
  SSE_UPDATE_FUNDING_MATCH_SUCCESS,
  SSE_UPDATE_FUNDING_MATCH_FAILURE,
};
